import moment from "moment";

const DateFormatter = (props) => {
  const runDateFormatter = (dateTimeString) => {
    const formattedDateTime =
      moment(dateTimeString).format("D MMMM YYYY");
    return formattedDateTime;
  };

  return {
    format: runDateFormatter,
  };
};

export default DateFormatter;
